import { useEffect } from "react";

const useResize = () => {
  const handleResize = () => {
    let fontSize = 15; // 1rem = 10px (default) 1920x1080
    let k = window.innerWidth / 1920;
    fontSize = fontSize * k;
    document.documentElement.style.fontSize = fontSize + "px";
  };

  useEffect(() => {
    handleResize(); // Initial call
    window.addEventListener("resize", handleResize);

    // Cleanup function
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array since we don't have any dependencies
};

export default useResize;
